import { useState } from "react";
import { AdminGate } from "@/components/admin/AdminGate";
import { SubscriberDashboard } from "@/components/admin/SubscriberDashboard";

const KEY_STORAGE = "dd_admin_token";

export default function Admin() {
  const [token, setToken] = useState(() => sessionStorage.getItem(KEY_STORAGE) || "");

  const login = (t) => {
    sessionStorage.setItem(KEY_STORAGE, t);
    setToken(t);
  };
  const logout = () => {
    sessionStorage.removeItem(KEY_STORAGE);
    setToken("");
  };

  return (
    <main data-testid="admin-page" className="bg-[#ffffff] text-[#0a0a0b] min-h-screen antialiased">
      {token ? <SubscriberDashboard adminKey={token} onLogout={logout} /> : <AdminGate onSuccess={login} />}
    </main>
  );
}
